// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const DIRECT_SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string;

if (!DIRECT_SUPABASE_URL || !SUPABASE_PUBLISHABLE_KEY) {
  throw new Error('Configuration Supabase manquante');
}

/**
 * Always talk to the Supabase project directly.
 * The previous same-origin gateway (/api/supabase) only exists on Vercel; on the
 * production hosting it returns index.html, which breaks auth on Safari/iOS with
 * "The string did not match the expected pattern".
 */
const SUPABASE_URL = DIRECT_SUPABASE_URL;


export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
  },
});
